import React, { lazy, Suspense } from "react";
import { LazyLoader } from "../../../assets/loaders";
const LazyComponent = lazy(() => import("./Service"));

export default function Service() {
  return (
    <Suspense fallback={<LazyLoader />}>
      <LazyComponent />
    </Suspense>
  );
}
